
import React, { useEffect, useState, useCallback } from "react";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import cn from "classnames";
import styles from "./utils.scss";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import { useWindowSize } from "services/resizeservice";

function EnergyComponent(props) {
  const [echartInstance, setEchartInstance] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    echartInstance?.resize();
  }, [size.width]);
  var testing = {
    totalChargerFaulted: 20,
    totalBatteryFaulted: 10,
    demo: 15,
    totalFault: 30,
  };
  const [totalFaultPie, setTotalFaultPie] = useState(0);
  const [data, setData] = useState([
    { value: 0, name: "Swap Stations" },
      { value: 0, name: "Batteries" },
  ]);

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    BarChart,
    CanvasRenderer,
  ]);

  const action = useCallback(
    (param) => {
      var fault = 0;
      data?.forEach((val) => {
        if (param?.selected[val.name]) {
          fault = fault + val.value;
        }
      });
      setTotalFaultPie(fault);
    },
    [data]
  );

  useEffect(() => {
    setTotalFaultPie(props?.data?.totalFault);
    const tempArr = [
      { value: props.data.totalChargerFaulted, name: "Swap Stations" },
      { value: props.data.totalBatteryFaulted, name: "Batteries" },
    ]
    setData(tempArr);
    var fault = 0;
    tempArr?.forEach((val) => {
      fault = fault + val.value;
    });
    setTotalFaultPie(fault);
  }, [props.selectValue]);

  const options = () => ({
    // title: {
    //   text: totalFaultPie ? totalFaultPie : 0,
    //   left: "center",
    //   top: "35%",
    //   height: 279,
    //   textStyle: {
    //     fontSize: 30,
    //     color: "#23297A",
    //   },
    // },
    color: ["#E3324C", "#770715", "yellow"],
    tooltip: {
      trigger: "item",
    },
    legend: {
      data: ["Batteries", "Swap Stations"],
      top: "85%",
      icon: "circle",
      left: "center",
    },

    series: [
      {
        type: "pie",
        radius: ["40%", "80%"],
        avoidLabelOverlap: true,
        top: "0%",
        bottom: "12%",
        label: {
          normal: {
            show: false,
            position: "center",
            left: "center",
            top: "35%",
            height: 279,
            textStyle: {
              fontSize: 35,
              fontFamily: "JioType",
              fontStyle: "normal",
              fontWeight: "bold",
              color: "#23297A",
            },
          },
        },
        data: data,
      },
    ],
  });

  return (
    <div>
      <p
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          position: "absolute",
          verticalAlign: "middle",
          height: "78%",
          width: "100%",
          fontSize: "2em",
          fontFamily: "JioType",
          fontStyle: "normal",
          fontWeight: "bold",
          color: "#23297A",
        }}
      >
        {totalFaultPie}
      </p>
      <ReactEcharts
        styles={{ position: "absolute", with: "100%", height: "90%" }}
        echarts={echarts}
        notMerge={true}
        lazyUpdate={true}
        theme={"theme_name"}
        opts={{ renderer: "svg" }}
        option={options()}
        onChartReady={(instance) => {
          setEchartInstance(instance);
        }}
        onEvents={{
          legendselectchanged: action,
        }}
      />
    </div>
  );
}

export default EnergyComponent;
